import React from 'react'
import { Box } from '@mui/material'
import BreadcrumbsPipe, { Path } from 'src/components/molecules/BreadcrumbsPipe'
import Guide from 'src/components/molecules/Guide'
import style from './styles.module.scss'

export type CompleteEditCalculationProps = {
  breadcrumbs: Path[]
  onClickClose: () => void
}

const CompleteEditCalculation: React.StyledFC<CompleteEditCalculationProps> = ({
  breadcrumbs,
  onClickClose,
}: CompleteEditCalculationProps) => {
  const buttons = [
    {
      index: 0,
      title: '閉じる',
      onClick: onClickClose,
    },
  ]

  return (
    <Box className={style.root}>
      <Box className={style.header} component="header">
        <BreadcrumbsPipe className={style.breadcrumb} paths={breadcrumbs} />
      </Box>
      <Box className={style.contentWrapper}>
        <Guide
          message="設定が
完了しました。"
          description="テナントの利用準備ができました。ステータスは利用中に変更になります。利用停止する場合などはステータスの変更をしましょう。"
          buttons={buttons}
          icon="clap"
        />
      </Box>
    </Box>
  )
}

export default CompleteEditCalculation
